"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONSchemaTargetLanguage = void 0;
const TargetLanguage_1 = require("../../TargetLanguage");
const TypeBuilder_1 = require("../../TypeBuilder");
const JSONSchemaRenderer_1 = require("./JSONSchemaRenderer");
class JSONSchemaTargetLanguage extends TargetLanguage_1.TargetLanguage {
    constructor() {
        super("JSON Schema", ["schema", "json-schema"], "schema");
    }
    getOptions() {
        return [];
    }
    get stringTypeMapping() {
        return (0, TypeBuilder_1.getNoStringTypeMapping)();
    }
    get supportsOptionalClassProperties() {
        return true;
    }
    get supportsFullObjectType() {
        return true;
    }
    makeRenderer(renderContext, _untypedOptionValues) {
        return new JSONSchemaRenderer_1.JSONSchemaRenderer(this, renderContext);
    }
}
exports.JSONSchemaTargetLanguage = JSONSchemaTargetLanguage;
